import React, { useState, useEffect } from "react"
import { Keyboard } from "~/ui/primitives"
import Mention from "./mention"
import { User } from "../../models"

interface Props {
  onChangeText: (value: string) => void
  onClose: () => void
}

const MentionMode: React.FC<Props> = ({ onChangeText, onClose }) => {
  const [visible, setVisible] = useState(true)

  const onSelect = (item: User) => {
    onChangeText(`${item.username} `)
    setVisible(false)
  }

  useEffect(() => {
    Keyboard.dismiss()
  }, [])

  useEffect(() => {
    if (!visible) {
      onClose()
    }
  }, [visible])

  return <Mention visible={visible} setVisible={setVisible} onSelect={onSelect} />
}

export default MentionMode
